var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowMoreIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.802 11.4096C22.802 11.7616 22.662 12.0996 22.413 12.3486C22.164 12.5976 21.826 12.7376 21.474 12.7376H13.063V21.1496C13.063 21.5016 12.923 21.8396 12.673 22.0886C12.424 22.3376 12.087 22.4776 11.734 22.4776C11.382 22.4776 11.044 22.3376 10.795 22.0886C10.546 21.8396 10.406 21.5016 10.406 21.1496V12.7376H1.99499C1.64299 12.7376 1.30499 12.5976 1.05599 12.3486C0.806993 12.0996 0.666992 11.7616 0.666992 11.4096C0.666992 11.0576 0.806993 10.7196 1.05599 10.4706C1.30499 10.2216 1.64299 10.0816 1.99499 10.0816H10.406V1.66955C10.406 1.31755 10.546 0.979553 10.795 0.730553C11.044 0.481553 11.382 0.341553 11.734 0.341553C12.087 0.341553 12.424 0.481553 12.673 0.730553C12.923 0.979553 13.063 1.31755 13.063 1.66955V10.0816H21.474C21.826 10.0816 22.164 10.2216 22.413 10.4706C22.662 10.7196 22.802 11.0576 22.802 11.4096Z",
    fill: "#292824"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMoreIcon);
export default __webpack_public_path__ + "static/media/showMoreIcon.a9fb9c396436ffeb10e5f38b743f82c6.svg";
export { ForwardRef as ReactComponent };